module.exports = __webpack_public_path__ + "static/media/utility.1e490676.png";